/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoadingIndicator } from '@/components/LoadingIndicator'
import ModalVoucherLogin from '@/components/Popup/ModalVoucherLogin'
import {
  AddToCartType,
  API_STATUS_CODE,
  CouponType,
  ServiceType,
  SHIPPING_METHOD,
} from '@/constants'
import { useAuth, useCart } from '@/containers'
import type {
  GiftItems,
  OrderService,
  OtherOffers,
  Product,
  ProductDetail,
  VoucherItem as VoucherItemType,
} from '@/types'
import { convertCoupon } from '@/utils/next-util'
import uniq from 'lodash/uniq'
import router from 'next/router'
import { useState } from 'react'
import VoucherItem from '../VoucherItem/VoucherItem'

interface Props {
  data: VoucherItemType[]
  addToCartData: ProductDetail
  listService?: OrderService[]
  listGift?: GiftItems[] | undefined
  listOffer?: OtherOffers[] | undefined
  pickUpInStore: boolean
}

export const ProductVoucherList = ({
  data,
  addToCartData,
  listService,
  listGift,
  listOffer,
  pickUpInStore,
}: Props) => {
  const { fetchCart, setVoucherApply, voucherApply } = useAuth()
  const { addToCart } = useCart()

  const [voucherChoose, setVoucherChoose] = useState<VoucherItemType>()
  const [isVoucherLoginOpen, setIsVoucherLoginOpen] = useState<boolean>(false)

  const dataProduct = {
    ...addToCartData,
    receiveAtWarehouse: pickUpInStore,
    selectedReceiveAtWarehouse: pickUpInStore,
    addGift: listGift?.map(item => {
      if (item.optionBuy) {
        if (item.calToCart) {
          return {
            _id: item._id,
            checked: true,
          }
        }
        return {
          _id: item._id,
          checked: false,
        }
      }
      if (!item.optionBuy) {
        if (item.calToCart) {
          return {
            _id: item._id,
            checked: true,
          }
        }
      }
      if (item.type == CouponType.COUPON) {
        return {
          _id: item._id,
          checked: true,
        }
      }
      return {
        _id: item._id,
        checked: false,
      }
    }),
    addService: listService?.filter(e => e.active).map(item => item._id),
    addOffer: listOffer?.map(item => ({
      _id: item?.content?._id,
      checked: item.active,
    })),
    shippingMethod: listService?.find(
      e =>
        (e.type === ServiceType.SHIPPING ||
          e.type === ServiceType.SHIPPING_AND_INSTALL) &&
        e.active
    )
      ? SHIPPING_METHOD.STANDARD
      : SHIPPING_METHOD.PICKUP_IN_STORE,
  } as Product | ProductDetail

  const [loading, setLoading] = useState<boolean>(false)
  const applyVoucherHandle = async (e: string) => {
    setLoading(true)
    setVoucherApply(
      uniq([
        ...voucherApply.filter((f: string) => !f.includes(dataProduct._id)),
        e,
      ])
    )
    addToCart(dataProduct, AddToCartType.BUY_NOW).then((res: any) => {
      if (res instanceof Error || !res) {
        fetchCart()
        if (res?.message == API_STATUS_CODE.PRODUCT_LIMIT_SALE) {
          setLoading(false)
          router.push('/checkout/cart')
        }
      }
    })
    setLoading(false)
  }
  const handleChoose = (e: VoucherItemType) => {
    setVoucherChoose({
      ...e,
      code: convertCoupon(e.code, dataProduct._id),
    })
    setIsVoucherLoginOpen(true)
  }

  if (!data) {
    return null
  }

  return (
    <div className='voucher-list flex flex-col gap-1'>
      {loading && <LoadingIndicator />}

      {data &&
        data?.map((e: VoucherItemType, i: number) => (
          <VoucherItem
            key={i}
            data={e}
            onChoose={() =>
              applyVoucherHandle(
                convertCoupon(e?.code, dataProduct._id) as string
              )
            }
            onApply={() => handleChoose(e)}
            className='h-14 px-4 text-sm'
          />
        ))}

      <ModalVoucherLogin
        isOpen={isVoucherLoginOpen}
        setIsOpen={() => setIsVoucherLoginOpen(false)}
        data={voucherChoose}
      />
    </div>
  )
}

export default ProductVoucherList
